
import { StepType } from 'src/app/shared/shared.module';
import { CommonVisaInputs } from './common-visa-inputs';
import { CommonService } from 'src/app/core/common.service';
import { ImmigrationApi } from 'src/app/core/api.gen';

export class VisaType extends CommonVisaInputs {

    constructor(
        common: CommonService,
        immigration: ImmigrationApi) {
        super(common, immigration) ;
    }

    VisaCommonInputs(): StepType[] {
        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.firstName(),
                            this.middleName(),
                            this.lastName()
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.nationality(),
                            this.passportNumber(),
                            this.placeOfBirth()
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.gender(),
                            this.officeLocation()
                        ]
                    }]
            }];
    }
}
